import { render, staticRenderFns } from "./ApiAccess.vue?vue&type=template&id=79274cfc"
import script from "./ApiAccess.vue?vue&type=script&lang=js"
export * from "./ApiAccess.vue?vue&type=script&lang=js"
import style0 from "./ApiAccess.vue?vue&type=style&index=0&id=79274cfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports